import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import { products } from "@/mock";
import ProductImage from "@/components/ProductImage";

export default function SearchOverlay({ open, onClose }) {
  const [q, setQ] = useState("");
  const results = useMemo(() => {
    if (!q) return products;
    const s = q.toLowerCase();
    return products.filter(
      (p) => p.name.toLowerCase().includes(s) || p.color.toLowerCase().includes(s)
    );
  }, [q]);

  return (
    <div
      className={`fixed inset-0 z-[80] bg-black/85 backdrop-blur-sm transition-opacity duration-300 ${
        open ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="max-w-3xl mx-auto pt-24 px-6">
        <div className="flex items-center border-b-2 border-white/30 pb-2">
          <Search size={22} className="text-white/70" />
          <input
            autoFocus={open}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products, colors, bundles..."
            className="flex-1 bg-transparent text-white text-xl md:text-2xl px-4 py-3 outline-none placeholder:text-white/40"
          />
          <button onClick={onClose} className="text-white/70 hover:text-white p-2">
            <X size={22} />
          </button>
        </div>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {results.map((p) => (
            <Link
              key={p.id}
              to={`/products/${p.id}`}
              onClick={onClose}
              className="text-left group"
            >
              <div className="aspect-square relative bg-[#0a0a0a] flex items-center justify-center overflow-hidden p-6">
                <ProductImage src={p.img} alt={p.color} />
              </div>
              <div className="mt-2 text-white text-[12px] tracking-[0.16em] uppercase group-hover:text-[#ff2626]">
                {p.color}
              </div>
              <div className="text-white/50 text-[12px]">${p.price}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
